module.exports = __webpack_public_path__ + "static/media/community-comment-post.ba30d43a.svg";